import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { AppStore } from '@aaa/emember/store-types';
import { getQueryPromoCodeQueryParam } from '../../../store/router/router.selectors';
import { DEFAULT_JOIN_PROMO_CODE } from '../../../constants/constants';

export const setDefaultPromo: CanActivateChildFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store<AppStore>);
  const router = inject(Router);

  return store.select(getQueryPromoCodeQueryParam).pipe(
    map((promo) => {
      if (!promo && DEFAULT_JOIN_PROMO_CODE) {
        const queryParams = {
          ...route.queryParams,
          promo: DEFAULT_JOIN_PROMO_CODE,
        };

        router.navigate(['join'], { queryParams });

        return false;
      }

      return true;
    }),
  );
};
export default setDefaultPromo;
